var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChannelmore({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5846 22.75V16.25M17.3346 19.5H23.8346M13.0013 16.25H8.66797C6.64889 16.25 5.63935 16.25 4.84301 16.5799C3.78122 17.0197 2.93763 17.8633 2.49782 18.925C2.16797 19.7214 2.16797 20.7309 2.16797 22.75M16.793 3.56499C18.381 4.20782 19.5013 5.76475 19.5013 7.58333C19.5013 9.40191 18.381 10.9588 16.793 11.6017M14.6263 7.58333C14.6263 9.97657 12.6862 11.9167 10.293 11.9167C7.89973 11.9167 5.95964 9.97657 5.95964 7.58333C5.95964 5.1901 7.89973 3.25 10.293 3.25C12.6862 3.25 14.6263 5.1901 14.6263 7.58333Z",
    stroke: "#000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChannelmore);
export default __webpack_public_path__ + "static/media/channelmore.fa06b521c94c6233082a7939a11ddb21.svg";
export { ForwardRef as ReactComponent };